// Egyptian Arabic, in the voice of the legacy app (peeksai/apps/garrabha copy): short, warm,
// one idea per line. Lines marked (written) are new for this client.
export const SITE_NAME = 'جرّبها';

export function pageTitle(title: string): string {
  return `${title} | ${SITE_NAME}`;
}

export const COMMON = {
  loading: 'بنحمّل...',
  retry: 'جرّب تاني',
  back: 'رجوع',
  cancel: 'إلغاء',
  save: 'احفظ',
  free: 'مجاني',
  currency: 'ج.م',
  required: 'لازم تكتب ده.',
  notFoundTitle: 'الصفحة دي مش موجودة',
  notFoundBody: 'يمكن اللينك قديم أو اتمسح.',
  toBoard: 'شوف التجارب',
  forbiddenTitle: 'مش مسموح',
  forbiddenBody: 'الصفحة دي للمراجعين بس.',
  anonymousOwner: 'صاحب التجربة',
  anonymousTrier: 'مُجرِّب',
} as const;

export const NAV = {
  owner: 'عندي حاجة تتجرّب',
  trier: 'هجرّب وأقول رأيي',
  signIn: 'دخول',
  account: 'حسابي',
  myRequests: 'طلباتي',
  signOut: 'خروج',
  admin: 'المراجعة',
  skip: 'روح للمحتوى',
  menuLabel: 'قايمة الحساب',
} as const;

export const AUTH = {
  title: 'ادخل بالإيميل',
  subtitle: 'هنبعتلك كود من 6 أرقام. مفيش باسورد تحفظه.',
  email: 'الإيميل',
  emailInvalid: 'اكتب إيميل صحيح.',
  send: 'ابعتلي الكود',
  checkTitle: 'شوف الإيميل',
  checkBody: (email: string) => `بعتنا كود لـ ${email}. اكتبه هنا.`,
  codeLabel: 'الكود',
  verify: 'ادخل',
  invalid: 'الكود غلط أو خلص وقته. جرّب تاني.',
  resend: 'ابعت الكود تاني',
  resendIn: (seconds: number) => `ابعته تاني بعد ${seconds} ثانية`,
  resent: 'بعتنا كود جديد.',
  changeEmail: 'غيّر الإيميل',
} as const;

/** Refusals by API code (see errorMessage). */
export const ERRORS = {
  generic: 'حصلت مشكلة. جرّب تاني.',
  network: 'إنت مش متصل بالنت. اتأكد وجرّب تاني.',
  unauthenticated: 'لازم تدخل الأول.',
  forbidden: 'مش مسموحلك بالحركة دي.',
  rateLimited: 'الطلبات كتير. جرّب بعد شوية.',
  conflict: 'حد غيّر الصفحة وإنت شغال. حدّث الصفحة وجرّب تاني.',
  byCode: {
    'garrabha.contact_blocked': 'ممنوع أرقام تليفونات أو إيميلات أو لينكات قبل ما تتمّموا الاتفاق.',
    'garrabha.profile_required': 'لازم ملفك يتراجع ويتوافق عليه قبل ما تبعت عرض.',
    'garrabha.trial_unavailable': 'التجربة دي مش بتقبل عروض دلوقتي.',
    'garrabha.trial_full': 'التجربة دي كمّلت عدد المُجرِّبين.',
    'garrabha.fee_not_accepted': 'لازم توافق على العمولة الأول.',
    'garrabha.own_trial': 'دي تجربتك، مينفعش تبعت عرض عليها.',
    'garrabha.offer_in_agreement': 'العرض ده داخل في اتفاق ومينفعش يتغيّر.',
    'garrabha.offer_not_approved': 'العرض ده لسه ماتوافقش عليه.',
    'garrabha.offer_exists': 'إنت بعتّ عرض على التجربة دي قبل كده.',
    'garrabha.trial_closed': 'التجربة دي اتقفلت.',
    'garrabha.trial_rejected': 'التجربة دي اترفضت وماينفعش تتعدّل.',
    'moderation.stale_version': 'الحالة دي اتغيّرت. حمّلنا آخر نسخة، راجعها تاني.',
    'moderation.case_closed': 'الحالة دي اتقفلت قبل كده.',
  } as Readonly<Record<string, string>>,
} as const;
